import { axiosInstance } from '@/modules/shared/lib/axios'
import {
  FetchMandatesAdvancesFromEasyTmsRequest,
  FetchMandatesAdvancesFromEasyTmsResponse,
} from './types'

export function fetchMandatesAdvancesFromEasyTms({
  companyId,
  ...body
}: FetchMandatesAdvancesFromEasyTmsRequest) {
  return axiosInstance.post<FetchMandatesAdvancesFromEasyTmsResponse>(
    `/api/${companyId}/timesheet/mandatesAdvancesFromEasyTms`,
    body,
  )
}
